// import React, { useEffect, useState } from "react";
// import type { FC, PropsWithChildren } from "react";
// import { ModalForm, Modal, Button, ModalButtons } from "../../components/Modal";
// import ModalHeading from "../../components/Modal/ModalHeading";
// import SkeletonLoader from "../../Skeletons/IntakeFormSkeleton";
// import InputWrapper from "../../components/Modal/InputWrapper";
// import SliderBar from "../../components/Modal/SlideBar";
// import TextAreaField from "../../components/Modal/TextAreaField";
// import RadioButton from "../../components/Modal/RadioButton";
// import CheckboxInput from "../../components/Modal/CheckBoxInput";
// import PatientStyle from "../../styles/Patient.module.css";
// import { IPatient } from "../../hooks/patients/index.type";
// import useIntakeForm from "../../hooks/patients/useIntakeForm";
// import useFetchIntakeForm from "../../hooks/patients/useFetchIntakeForm";
// import useUpdatePatientIntakeForm, {
//   type IntakeFormData,
// } from "../../hooks/patients/useUpdatePatientIntakeForm";
// import toast from "react-hot-toast";

// interface IntakeFormRecordOption {
//   key: string;
//   name: string;
//   textboxRequired: string;
// }

// interface IntakeFormScale {
//   min: IntakeFormRecordOption;
//   max: IntakeFormRecordOption;
// }

// interface IntakeFormCategory {
//   _id: string;
//   key?: string;
//   name: string;
//   sequence: number;
// }

// interface IntakeFormRecord {
//   _id: string;
//   id: string;
//   answer: any;
//   more_details?: { [key: string]: string };
//   type: string;
//   text: string;
//   options: IntakeFormRecordOption[];
//   scale?: IntakeFormScale;
//   category: IntakeFormCategory;
// }

// interface IntakeFormCategoryData {
//   _id: string;
//   name: string;
//   sequence: number;
//   records: IntakeFormRecord[];
// }

// type IntakeFormViewModalProps = PropsWithChildren<{
//   show: boolean;
//   onClose: () => void;
//   patient: IPatient;
//   canEdit?: "yes" | "no";
//   intakeFormStatusLoading?: boolean;
//   onUpdateSuccess?: () => void;
// }>;

// const IntakeFormViewModal: FC<IntakeFormViewModalProps> = (props) => {
//   const [isEditable, setIsEditable] = useState(false);
//   const { getIntakeFormData, intakeFormData, intakeFormLoading, planId } =
//     useIntakeForm({
//       patientId: props.patient._id,
//     });

//   const [formState, setFormState] = useState<{ [key: string]: any }>({});
//   const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [hasChanges, setHasChanges] = useState(false);

//   const {
//     intakeForm: intakeFormTemplate,
//     getIntakeFormData: fetchIntakeFormTemplate,
//     intakeFormLoading: templateLoading,
//   } = useFetchIntakeForm({
//     planId: planId || "",
//   });

//   const { updatePatientIntakeForm, isUpdating } = useUpdatePatientIntakeForm(
//     props.patient._id || ""
//   );

//   useEffect(() => {
//     if (props.show) {
//       getIntakeFormData();
//     }
//   }, [props.show]);

//   useEffect(() => {
//     if (isEditable && intakeFormTemplate?.data?.data) {
//       setHasChanges(false);
//       const initialState: { [key: string]: any } = {};

//       intakeFormTemplate.data.data.forEach((category) => {
//         category.records?.forEach((record) => {
//           const existingAnswer = intakeFormData
//             ?.flatMap((cat) => cat.records)
//             ?.find((r) => r.id === record.questionId)?.answer;

//           if (existingAnswer !== undefined) {
//             initialState[record.questionId] = existingAnswer;

//             const existingRecord = intakeFormData
//               ?.flatMap((cat) => cat.records)
//               ?.find((r) => r.id === record.questionId);

//             if (existingRecord?.more_details) {
//               if (record.answerType === "single_option") {
//                 const selectedOption = record.option?.find(
//                   (opt) => opt.name === existingAnswer
//                 );
//                 if (selectedOption?.textboxRequired === "yes") {
//                   initialState[
//                     `${record.questionId}_${existingAnswer}_textbox`
//                   ] =
//                     typeof existingRecord.more_details === "string"
//                       ? existingRecord.more_details
//                       : Object.values(existingRecord.more_details)[0];
//                 }
//               } else if (
//                 record.answerType === "multiple_option" &&
//                 Array.isArray(existingAnswer)
//               ) {
//                 existingAnswer.forEach((optName: string) => {
//                   const option = record.option?.find(
//                     (opt) => opt.name === optName
//                   );
//                   if (
//                     option?.textboxRequired === "yes" &&
//                     existingRecord.more_details?.[optName]
//                   ) {
//                     initialState[`${record.questionId}_${optName}_textbox`] =
//                       existingRecord.more_details[optName];
//                   }
//                 });
//               }
//             }
//           } else if (record.scale) {
//             initialState[record.questionId] = 0;
//           }
//         });
//       });

//       setFormState(initialState);
//     }
//   }, [isEditable, intakeFormTemplate]);

//   const handleEditClick = async () => {
//     if (!planId) {
//       toast.error("No plan ID found for this patient");
//       return;
//     }

//     try {
//       setIsEditable(true);
//       await fetchIntakeFormTemplate({ clearFirst: true });
//     } catch (error) {
//       toast.error("Failed to fetch intake form template");
//       setIsEditable(false);
//     }
//   };

//   const handleCancelEdit = () => {
//     if (hasChanges) {
//       setShowConfirmModal(true);
//     } else {
//       setIsEditable(false);
//       setFormState({});
//       setFormErrors({});
//     }
//   };

//   const handleConfirmCancel = () => {
//     setShowConfirmModal(false);
//     setIsEditable(false);
//     setFormState({});
//     setFormErrors({});
//     setHasChanges(false);
//   };

//   const handleAbortCancel = () => {
//     setShowConfirmModal(false);
//   };

//   const updateState = (field: string, value: any) => {
//     setFormState((prev) => ({
//       ...prev,
//       [field]: value,
//     }));

//     if (formErrors[field]) {
//       setFormErrors((prev) => {
//         const updated = { ...prev };
//         delete updated[field];
//         return updated;
//       });
//     }
//     setHasChanges(true);
//   };

//   const toggleCheckbox = (field: string, label: string) => {
//     setFormState((prev) => {
//       const current = prev[field];
//       const list = Array.isArray(current) ? current : [];
//       const updated = list.includes(label)
//         ? list.filter((item) => item !== label)
//         : [...list, label];
//       return { ...prev, [field]: updated };
//     });

//     if (formErrors[field]) {
//       setFormErrors((prev) => {
//         const updated = { ...prev };
//         delete updated[field];
//         return updated;
//       });
//     }
//     setHasChanges(true);
//   };
//   const validateForm = (): boolean => {
//     const errors: { [key: string]: string } = {};
//     let isValid = true;

//     if (!intakeFormTemplate?.data?.data) {
//       return false;
//     }

//     intakeFormTemplate.data.data.forEach((category) => {
//       category.records?.forEach((record) => {
//         const questionId = (record as any).questionId || (record as any).id;
//         const answer = formState[questionId];
//         const answerType = (record as any).answerType || (record as any).type;

//         switch (answerType) {
//           case "single_option":
//             if (!answer) {
//               errors[questionId] = "Please select an option";
//               isValid = false;
//             }
//             break;

//           case "multiple_option":
//             if (!answer || answer.length === 0) {
//               errors[questionId] = "Please select at least one option";
//               isValid = false;
//             }
//             break;

//           case "scale":
//             if (answer === undefined || answer === null || answer === "") {
//               errors[questionId] = "Please select a value on the scale";
//               isValid = false;
//             }
//             break;

//           case "textarea":
//             if (!answer?.trim()) {
//               errors[questionId] = "Please provide an answer";
//               isValid = false;
//             }
//             break;
//         }
//       });
//     });

//     setFormErrors(errors);
//     return isValid;
//   };

//   // const handleSaveEdit = async () => {
//   //   if (!props.patient._id) {
//   //     toast.error("Patient ID is required to save the form");
//   //     return;
//   //   }

//   //   if (!validateForm()) {
//   //     toast.error("Please fill in all required fields");
//   //     return;
//   //   }

//   //   try {
//   //     const payload = transformFormDataForAPI();
//   //     if (payload.intakeForm.length === 0) {
//   //       toast.error("No data to save");
//   //       return;
//   //     }

//   //     const result = await updatePatientIntakeForm(payload);
//   //     if (result?.status === "success") {
//   //       toast.success(result.message || "Intake form updated successfully");
//   //       setIsEditable(false);
//   //       setHasChanges(false);
//   //       getIntakeFormData();
//   //       if (props.onUpdateSuccess) props.onUpdateSuccess();
//   //       props.onClose();
//   //     } else {
//   //       toast.error(result?.message || "Failed to update intake form.");
//   //     }
//   //   } catch (error: any) {
//   //     console.error("Error saving intake form:", error);
//   //     const errorMessage =
//   //       error.response?.data?.message ||
//   //       error.message ||
//   //       "An error occurred while saving the form.";
//   //     toast.error(errorMessage);
//   //   }
//   // };
//   // const validateForm = (): boolean => {
//   //   const errors: { [key: string]: string } = {};
//   //   let isValid = true;

//   //   if (!intakeFormTemplate?.data?.data) {
//   //     return false;
//   //   }

//   //   intakeFormTemplate.data.data.forEach((category) => {
//   //     category.records?.forEach((record) => {
//   //       const questionId = record.questionId;
//   //       const answer = formState[questionId];
//   //       const answerType = record.answerType;

//   //       if (record.scale) {
//   //         return;
//   //       }

//   //       if (answerType === "single_option" && !answer) {
//   //         errors[questionId] = "Please select an option";
//   //         isValid = false;
//   //       } else if (
//   //         answerType === "multiple_option" &&
//   //         (!answer || answer.length === 0)
//   //       ) {
//   //         errors[questionId] = "Please select at least one option";
//   //         isValid = false;
//   //       } else if (answerType === "textarea" && !answer?.trim()) {
//   //         errors[questionId] = "Please provide an answer";
//   //         isValid = false;
//   //       }
//   //     });
//   //   });

//   //   setFormErrors(errors);
//   //   return isValid;
//   // };

//   const transformFormDataForAPI = (): { intakeForm: IntakeFormData[] } => {
//     const intakeForm: IntakeFormData[] = [];

//     if (!intakeFormTemplate?.data?.data) {
//       return { intakeForm };
//     }

//     intakeFormTemplate.data.data.forEach((category) => {
//       category.records?.forEach((record) => {
//         const questionId = (record as any).questionId || (record as any).id;
//         const answer = formState[questionId];
//         const answerType = (record as any).answerType || (record as any).type;

//         const shouldInclude = record.scale
//           ? answer !== undefined && answer !== null
//           : answer !== undefined && answer !== null && answer !== "";

//         if (shouldInclude) {
//           const backendAnswerType =
//             answerType === "single_option"
//               ? "single_select"
//               : answerType === "multiple_option"
//               ? "multi_select"
//               : answerType;

//           const formData: IntakeFormData = {
//             question_id: questionId,
//             question_answer:
//               typeof answer === "string" ? answer.trim() : answer,
//             question_type: backendAnswerType,
//           };

//           const moreDetails: { [key: string]: string } = {};

//           if (answerType === "single_option" && answer) {
//             const selectedOption = record.option?.find(
//               (opt) => opt.name === answer
//             );
//             if (selectedOption?.textboxRequired === "yes") {
//               const textboxValue = formState[`${questionId}_${answer}_textbox`];
//               if (textboxValue) {
//                 moreDetails[answer] = textboxValue.trim();
//               }
//             }
//           } else if (
//             answerType === "multiple_option" &&
//             Array.isArray(answer)
//           ) {
//             answer.forEach((optName: string) => {
//               const option = record.option?.find((opt) => opt.name === optName);
//               if (option?.textboxRequired === "yes") {
//                 const textboxValue =
//                   formState[`${questionId}_${optName}_textbox`];
//                 if (textboxValue) {
//                   moreDetails[optName] = textboxValue.trim();
//                 }
//               }
//             });
//           }

//           if (Object.keys(moreDetails).length > 0) {
//             formData.more_details = moreDetails;
//           }

//           intakeForm.push(formData);
//         }
//       });
//     });

//     return { intakeForm };
//   };

//   const handleSaveEdit = async () => {

//     if (!props.patient._id) {
//       toast.error("Patient ID is required to save the form");
//       return;
//     }

//     if (!validateForm()) {
//       toast.error("Please fill in all required fields");
//       return;
//     }

//     try {
//       const payload = transformFormDataForAPI();

//       if (payload.intakeForm.length === 0) {
//         toast.error("No data to save");
//         return;
//       }

//       const result = await updatePatientIntakeForm(payload);

//       if (result) {
//         if (result?.status === "success") {
//           toast.success("Intake form updated successfully");
//           setIsEditable(false);
//           setHasChanges(false);
//           getIntakeFormData();
//           if (props.onUpdateSuccess) {
//             props.onUpdateSuccess();
//           }
//           props.onClose();
//         }
//       }
//     } catch (error) {
//       console.error("Error saving intake form:", error);
//       toast.error("Failed to save intake form");
//     }
//   };

//   const renderQuestionContent = (
//     record: any,
//     idx: number,
//     showCategoryTitle: boolean = false,
//     categoryName?: string
//   ) => {
//     const answerType = record.answerType || record.type;
//     const options = record.option || record.options || [];
//     const inputWrapperTitle =
//       showCategoryTitle && categoryName ? categoryName : undefined;

//     const serialNumber = idx + 1;
//     const questionId = record.questionId || record.id;
//     const error = formErrors[questionId];

//     return (
//       <div
//         key={record._id || record.questionId || record.id || idx}
//         className={PatientStyle.question_container}
//       >
//         {answerType === "single_option" && (
//           <InputWrapper
//             subTitle={`${serialNumber}. ${record.text}`}
//             title={inputWrapperTitle}
//             error={error}
//           >
//             {isEditable ? (
//               <div className={PatientStyle.option_container}>
//                 {options.map((opt: any) => (
//                   <div key={opt.key} className={PatientStyle.option_row}>
//                     <RadioButton
//                       label={opt.name}
//                       checked={
//                         formState[record.questionId || record.id] === opt.name
//                       }
//                       onChange={() => {
//                         updateState(record.questionId || record.id, opt.name);

//                         options.forEach((otherOpt: any) => {
//                           if (
//                             otherOpt.name !== opt.name &&
//                             otherOpt.textboxRequired === "yes"
//                           ) {
//                             updateState(
//                               `${record.questionId || record.id}_${
//                                 otherOpt.name
//                               }_textbox`,
//                               ""
//                             );
//                           }
//                         });
//                       }}
//                     />
//                     {opt.textboxRequired === "yes" &&
//                       formState[record.questionId || record.id] ===
//                         opt.name && (
//                         <TextAreaField
//                           rows={2}
//                           placeholder="Please specify"
//                           value={
//                             formState[
//                               `${record.questionId || record.id}_${
//                                 opt.name
//                               }_textbox`
//                             ] || ""
//                           }
//                           onChange={(e) =>
//                             updateState(
//                               `${record.questionId || record.id}_${
//                                 opt.name
//                               }_textbox`,
//                               e.target.value
//                             )
//                           }
//                         />
//                       )}
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className={PatientStyle.option_container}>
//                 {options.map((opt: any) => {
//                   const checked = record.answer === opt.name;
//                   return (
//                     <div key={opt.key} className={PatientStyle.option_row}>
//                       <RadioButton
//                         label={opt.name}
//                         checked={checked}
//                         // disable
//                         onChange={() => {}}
//                       />
//                       {opt.textboxRequired === "yes" &&
//                         checked &&
//                         record.more_details?.[opt.name] && (
//                           <TextAreaField
//                             rows={2}
//                             value={record.more_details[opt.name]}
//                             // disabled
//                           />
//                         )}
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </InputWrapper>
//         )}

//         {answerType === "multiple_option" && (
//           <InputWrapper
//             subTitle={`${serialNumber}. ${record.text}`}
//             title={inputWrapperTitle}
//             error={error}
//           >
//             <div className={PatientStyle.checkbox_div_1}>
//               {options.map((opt: any) => {
//                 const checked = isEditable
//                   ? (formState[record.questionId || record.id] || []).includes(
//                       opt.name
//                     )
//                   : Array.isArray(record.answer) &&
//                     record.answer.includes(opt.name);

//                 return (
//                   <div key={opt.key} className={PatientStyle.option_row}>
//                     <CheckboxInput
//                       label={opt.name}
//                       checked={checked}
//                       // disabled={isEditable}
//                       onChange={() =>
//                         isEditable &&
//                         toggleCheckbox(record.questionId || record.id, opt.name)
//                       }
//                     />
//                     {opt.textboxRequired === "yes" && checked && (
//                       <TextAreaField
//                         rows={2}
//                         placeholder="Please specify"
//                         value={
//                           isEditable
//                             ? formState[
//                                 `${record.questionId || record.id}_${
//                                   opt.name
//                                 }_textbox`
//                               ] || ""
//                             : record.more_details?.[opt.name] || ""
//                         }
//                         onChange={(e) =>
//                           isEditable &&
//                           updateState(
//                             `${record.questionId || record.id}_${
//                               opt.name
//                             }_textbox`,
//                             e.target.value
//                           )
//                         }
//                         // disabled={isEditable}
//                       />
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </InputWrapper>
//         )}

//         {answerType === "textarea" && (
//           <InputWrapper
//             subTitle={`${serialNumber}. ${record.text}`}
//             title={inputWrapperTitle}
//             error={error}
//           >
//             {isEditable ? (
//               <TextAreaField
//                 rows={4}
//                 value={formState[record.questionId || record.id] || ""}
//                 onChange={(e) =>
//                   updateState(record.questionId || record.id, e.target.value)
//                 }
//               />
//             ) : (
//               <div className={PatientStyle.text_answer}>
//                 <p>{record.answer?.toString() || "No answer provided"}</p>
//               </div>
//             )}
//           </InputWrapper>
//         )}

//         {answerType === "scale" && (
//           <InputWrapper
//             subTitle={`${serialNumber}. ${record.text}`}
//             title={inputWrapperTitle}
//             error={error}
//           >
//             <SliderBar
//               scale
//               value={
//                 isEditable
//                   ? formState[record.questionId || record.id] || 0
//                   : typeof record.answer === "number"
//                   ? record.answer
//                   : typeof record.answer === "string"
//                   ? parseInt(record.answer) || 0
//                   : 0
//               }
//               onChange={(value: number) =>
//                 updateState(record.questionId || record.id, value)
//               }
//               customLabel
//               min={record.scale?.min?.key ? parseInt(record.scale.min.key) : 0}
//               max={record.scale?.max?.key ? parseInt(record.scale.max.key) : 10}
//               leftLabel={record.scale?.min?.name || "Min"}
//               rightLabel={record.scale?.max?.name || "Max"}
//               disabled={!isEditable}
//             />
//           </InputWrapper>
//         )}
//       </div>
//     );
//   };

//   return (
//     <Modal show={props.show} modalClassName={PatientStyle.customEnrollModal}>
//       <Modal show={showConfirmModal}>
//         <ModalHeading heading="Cancel Edit" />
//         <ModalForm
//           style={{ marginBottom: "2.5rem" }}
//           onSubmit={(e) => {
//             e.preventDefault();
//             handleConfirmCancel();
//           }}
//         >
//           <InputWrapper>
//             <p className="primaryText">
//               Are you sure you want to cancel editing? All changes will be lost.
//             </p>
//           </InputWrapper>

//           <ModalButtons
//             submitButtonLabel="Confirm"
//             cancelButtonLabel="Cancel"
//             onCancel={handleAbortCancel}
//           />
//         </ModalForm>
//       </Modal>
//       <ModalHeading
//         heading={
//           <div style={{ display: "flex", alignItems: "center" }}>
//             <span>
//               {isEditable
//                 ? intakeFormTemplate?.data.templateName || "Edit Intake Form"
//                 : "Patient Intake Form"}
//             </span>
//             {!props.intakeFormStatusLoading &&
//               props.canEdit === "yes" &&
//               !isEditable && (
//                 <div style={{ marginLeft: "1rem" }}>
//                   <Button
//                     label="Edit"
//                     icon="icon-edit-2"
//                     span={false}
//                     iconStyle={{ height: "1.5rem", width: "1.5rem" }}
//                     customClass={PatientStyle.save_data_btn}
//                     onClick={handleEditClick}
//                   />
//                 </div>
//               )}
//           </div>
//         }
//         customClass={[PatientStyle.customEnrollHeading].join(" ")}
//         customCloseClass={PatientStyle.close_btn}
//         closeIcon="close-cross"
//         onClose={isEditable ? handleCancelEdit : props.onClose}
//       />

//       {intakeFormLoading || (isEditable && templateLoading) ? (
//         <SkeletonLoader />
//       ) : (
//         <ModalForm customClass={PatientStyle.enroll_ModalForm} id="intake-form">
//           <div
//             className={PatientStyle.enroll_ModalForm_inner}
//             style={{ marginBottom: "1rem" }}
//           >
//             {isEditable ? (
//               intakeFormTemplate?.data?.data ? (
//                 intakeFormTemplate.data.data.map((category, categoryIdx) => (
//                   <div
//                     key={category._id || `category-${categoryIdx}`}
//                     className={PatientStyle.custom_content}
//                   >
//                     {category.records &&
//                       category.records.map((record, idx) =>
//                         renderQuestionContent(
//                           record,
//                           idx,
//                           idx === 0,
//                           category.name
//                         )
//                       )}
//                   </div>
//                 ))
//               ) : (
//                 <p>No intake form template available for editing.</p>
//               )
//             ) : !intakeFormData || intakeFormData.length === 0 ? (
//               <p>No intake form data available for this patient.</p>
//             ) : (
//               intakeFormData.map((category, categoryIdx) => (
//                 <div
//                   key={category._id || `category-${categoryIdx}`}
//                   className={PatientStyle.custom_content}
//                 >
//                   {category.records &&
//                     category.records.map((record, idx) =>
//                       renderQuestionContent(
//                         record,
//                         idx,
//                         idx === 0,
//                         category.name
//                       )
//                     )}
//                 </div>
//               ))
//             )}
//           </div>
//           <div className={PatientStyle.custom_btn_box}>
//             {isEditable ? (
//               <>
//                 <Button
//                   label="Cancel"
//                   icon="icon-close-cross"
//                   span={false}
//                   iconStyle={{ height: "1.5rem", width: "1.5rem" }}
//                   customClass={PatientStyle.cancel_btn}
//                   onClick={handleCancelEdit}
//                   form="intake-form"
//                 />
//                 <Button
//                   icon="icon-save"
//                   label={isUpdating ? "Saving..." : "Save"}
//                   span={false}
//                   iconStyle={{ height: "1.5rem", width: "1.5rem" }}
//                   customClass={PatientStyle.save_data_btn}
//                   onClick={handleSaveEdit}
//                   disabled={isUpdating}
//                 />
//               </>
//             ) : (
//               <Button
//                 label="Close"
//                 icon="icon-close-cross"
//                 span={false}
//                 iconStyle={{ height: "1.5rem", width: "1.5rem" }}
//                 customClass={PatientStyle.cancel_btn}
//                 onClick={props.onClose}
//                 form="intake-form"
//               />
//             )}
//           </div>
//         </ModalForm>
//       )}
//     </Modal>
//   );
// };

// export default IntakeFormViewModal;

import React, { useEffect, useState } from "react";
import type { FC, PropsWithChildren } from "react";
import { ModalForm, Modal, Button, ModalButtons } from "../../components/Modal";
import ModalHeading from "../../components/Modal/ModalHeading";
import SkeletonLoader from "../../Skeletons/IntakeFormSkeleton";
import InputWrapper from "../../components/Modal/InputWrapper";
import SliderBar from "../../components/Modal/SlideBar";
import TextAreaField from "../../components/Modal/TextAreaField";
import RadioButton from "../../components/Modal/RadioButton";
import CheckboxInput from "../../components/Modal/CheckBoxInput";
import PatientStyle from "../../styles/Patient.module.css";
import { IPatient } from "../../hooks/patients/index.type";
import useIntakeForm from "../../hooks/patients/useIntakeForm";
import useFetchIntakeForm from "../../hooks/patients/useFetchIntakeForm";
import useUpdatePatientIntakeForm, {
  type IntakeFormData,
} from "../../hooks/patients/useUpdatePatientIntakeForm";
import toast from "react-hot-toast";

interface IntakeFormRecordOption {
  key: string;
  name: string;
  textboxRequired: string;
}

interface IntakeFormScale {
  min: IntakeFormRecordOption;
  max: IntakeFormRecordOption;
}

interface IntakeFormCategory {
  _id: string;
  key?: string;
  name: string;
  sequence: number;
}

interface IntakeFormRecord {
  _id: string;
  id: string;
  answer: any;
  more_details?: { [key: string]: string };
  type: string;
  text: string;
  options: IntakeFormRecordOption[];
  scale?: IntakeFormScale;
  category: IntakeFormCategory;
}

interface IntakeFormCategoryData {
  _id: string;
  name: string;
  sequence: number;
  records: IntakeFormRecord[];
}

type IntakeFormViewModalProps = PropsWithChildren<{
  show: boolean;
  onClose: () => void;
  patient: IPatient;
  canEdit?: "yes" | "no";
  intakeFormStatusLoading?: boolean;
  onUpdateSuccess?: () => void;
}>;

const IntakeFormViewModal: FC<IntakeFormViewModalProps> = (props) => {
  const [isEditable, setIsEditable] = useState(false);
  const { getIntakeFormData, intakeFormData, intakeFormLoading, planId } =
    useIntakeForm({
      patientId: props.patient._id,
    });

  const [formState, setFormState] = useState<{ [key: string]: any }>({});
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [touchedFields, setTouchedFields] = useState<{
    [key: string]: boolean;
  }>({});

  const {
    intakeForm: intakeFormTemplate,
    getIntakeFormData: fetchIntakeFormTemplate,
    intakeFormLoading: templateLoading,
  } = useFetchIntakeForm({
    planId: planId || "",
  });

  const { updatePatientIntakeForm, isUpdating } = useUpdatePatientIntakeForm(
    props.patient._id || ""
  );

  useEffect(() => {
    if (props.show) {
      getIntakeFormData();
    }
  }, [props.show]);

  // Helper function to get consistent property values from record
  const getRecordProperty = (record: any, property: string) => {
    switch (property) {
      case "questionId":
        return record.questionId || record.id;
      case "answerType":
        return record.answerType || record.type;
      case "options":
        return record.option || record.options || [];
      default:
        return record[property];
    }
  };

  useEffect(() => {
    if (isEditable && intakeFormTemplate?.data?.data) {
      setHasChanges(false);
      const initialState: { [key: string]: any } = {};

      intakeFormTemplate.data.data.forEach((category) => {
        category.records?.forEach((record) => {
          const questionId = getRecordProperty(record, "questionId");
          const answerType = getRecordProperty(record, "answerType");
          const options = getRecordProperty(record, "options");

          // Find existing answer from current intake form data
          const existingAnswer = intakeFormData
            ?.flatMap((cat) => cat.records)
            ?.find(
              (r) => getRecordProperty(r, "questionId") === questionId
            )?.answer;

          if (existingAnswer !== undefined && existingAnswer !== null) {
            initialState[questionId] = existingAnswer;

            const existingRecord = intakeFormData
              ?.flatMap((cat) => cat.records)
              ?.find((r) => getRecordProperty(r, "questionId") === questionId);

            if (existingRecord?.more_details) {
              if (answerType === "single_option") {
                const selectedOption = options.find(
                  (opt: any) => opt.name === existingAnswer
                );
                if (selectedOption?.textboxRequired === "yes") {
                  initialState[`${questionId}_${existingAnswer}_textbox`] =
                    typeof existingRecord.more_details === "string"
                      ? existingRecord.more_details
                      : Object.values(existingRecord.more_details)[0];
                }
              } else if (
                answerType === "multiple_option" &&
                Array.isArray(existingAnswer)
              ) {
                existingAnswer.forEach((optName: string) => {
                  const option = options.find(
                    (opt: any) => opt.name === optName
                  );
                  if (
                    option?.textboxRequired === "yes" &&
                    existingRecord.more_details?.[optName]
                  ) {
                    initialState[`${questionId}_${optName}_textbox`] =
                      existingRecord.more_details[optName];
                  }
                });
              }
            }
          } else {
            // Set default values for empty forms
            if (answerType === "scale") {
              initialState[questionId] = null;
            } else if (answerType === "multiple_option") {
              initialState[questionId] = [];
            } else {
              initialState[questionId] = "";
            }
          }
        });
      });

      setFormState(initialState);
    }
  }, [isEditable, intakeFormTemplate, intakeFormData]);

  const handleEditClick = async () => {
    if (!planId) {
      toast.error("No plan ID found for this patient");
      return;
    }

    try {
      setIsEditable(true);
      await fetchIntakeFormTemplate({ clearFirst: true });
    } catch (error) {
      toast.error("Failed to fetch intake form template");
      setIsEditable(false);
    }
  };

  const handleCancelEdit = () => {
    if (hasChanges) {
      setShowConfirmModal(true);
    } else {
      setIsEditable(false);
      setFormState({});
      setFormErrors({});
    }
  };

  const handleConfirmCancel = () => {
    setShowConfirmModal(false);
    setIsEditable(false);
    setFormState({});
    setFormErrors({});
    setHasChanges(false);
  };

  const handleAbortCancel = () => {
    setShowConfirmModal(false);
  };

  const updateState = (field: string, value: any) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (formErrors[field]) {
      setFormErrors((prev) => {
        const updated = { ...prev };
        delete updated[field];
        return updated;
      });
    }
    setHasChanges(true);
  };

  const toggleCheckbox = (field: string, label: string) => {
    setFormState((prev) => {
      const current = prev[field];
      const list = Array.isArray(current) ? current : [];
      const updated = list.includes(label)
        ? list.filter((item) => item !== label)
        : [...list, label];
      return { ...prev, [field]: updated };
    });

    if (formErrors[field]) {
      setFormErrors((prev) => {
        const updated = { ...prev };
        delete updated[field];
        return updated;
      });
    }
    setHasChanges(true);
  };

  const validateForm = (): boolean => {
    const errors: { [key: string]: string } = {};
    let isValid = true;

    if (!intakeFormTemplate?.data?.data) {
      return false;
    }

    intakeFormTemplate.data.data.forEach((category) => {
      category.records?.forEach((record) => {
        const questionId = getRecordProperty(record, "questionId");
        const answerType = getRecordProperty(record, "answerType");
        const answer = formState[questionId];

        // Validation based on answer type
        switch (answerType) {
          case "single_option":
            if (!answer || answer === "") {
              errors[questionId] = "Please select an option";
              isValid = false;
            }
            break;

          case "multiple_option":
            if (!answer || !Array.isArray(answer) || answer.length === 0) {
              errors[questionId] = "Please select at least one option";
              isValid = false;
            }
            break;

          case "scale":
            if (answer === undefined || answer === null || answer === "") {
              errors[questionId] = "Please select a value on the scale";
              isValid = false;
            }
            break;

          case "textarea":
            if (!answer || typeof answer !== "string" || !answer.trim()) {
              errors[questionId] = "Please provide an answer";
              isValid = false;
            }
            break;

          default:
            // Handle any other types
            if (!answer && answer !== 0) {
              errors[questionId] = "This field is required";
              isValid = false;
            }
            break;
        }
      });
    });

    setFormErrors(errors);
    return isValid;
  };

  const transformFormDataForAPI = (): { intakeForm: IntakeFormData[] } => {
    const intakeForm: IntakeFormData[] = [];

    if (!intakeFormTemplate?.data?.data) {
      return { intakeForm };
    }

    intakeFormTemplate.data.data.forEach((category) => {
      category.records?.forEach((record) => {
        const questionId = getRecordProperty(record, "questionId");
        const answerType = getRecordProperty(record, "answerType");
        const options = getRecordProperty(record, "options");
        let answer = formState[questionId];
        if (
          answerType === "scale" &&
          (answer === null || answer === undefined)
        ) {
          answer = 0;
        }

        // Include answer if it has a meaningful value
        const shouldInclude =
          answer !== undefined &&
          answer !== null &&
          answer !== "" &&
          !(Array.isArray(answer) && answer.length === 0);

        if (shouldInclude) {
          // Map frontend answer types to backend types
          const backendAnswerType =
            answerType === "single_option"
              ? "single_select"
              : answerType === "multiple_option"
              ? "multi_select"
              : answerType;

          const formData: IntakeFormData = {
            question_id: questionId,
            question_answer:
              typeof answer === "string" ? answer.trim() : answer,
            question_type: backendAnswerType,
          };

          // Handle additional text inputs (more_details)
          const moreDetails: { [key: string]: string } = {};

          if (answerType === "single_option" && answer) {
            const selectedOption = options.find(
              (opt: any) => opt.name === answer
            );
            if (selectedOption?.textboxRequired === "yes") {
              const textboxValue = formState[`${questionId}_${answer}_textbox`];
              if (textboxValue && textboxValue.trim()) {
                moreDetails[answer] = textboxValue.trim();
              }
            }
          } else if (
            answerType === "multiple_option" &&
            Array.isArray(answer)
          ) {
            answer.forEach((optName: string) => {
              const option = options.find((opt: any) => opt.name === optName);
              if (option?.textboxRequired === "yes") {
                const textboxValue =
                  formState[`${questionId}_${optName}_textbox`];
                if (textboxValue && textboxValue.trim()) {
                  moreDetails[optName] = textboxValue.trim();
                }
              }
            });
          }

          if (Object.keys(moreDetails).length > 0) {
            formData.more_details = moreDetails;
          }

          intakeForm.push(formData);
        }
      });
    });

    return { intakeForm };
  };

  const handleSaveEdit = async () => {
    if (!props.patient._id) {
      toast.error("Patient ID is required to save the form");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in all required fields");
      return;
    }

    try {
      const payload = transformFormDataForAPI();

      // Allow saving even if no data to handle cases where all fields are optional or cleared
      console.log("Payload being sent:", payload);

      const result = await updatePatientIntakeForm(payload);

      if (result && result.status === "success") {
        toast.success(result.message || "Intake form updated successfully");
        setIsEditable(false);
        setHasChanges(false);
        getIntakeFormData(); // Refresh the data
        if (props.onUpdateSuccess) {
          props.onUpdateSuccess();
        }
        props.onClose();
      } else {
        toast.error(result?.message || "Failed to update intake form");
      }
    } catch (error: any) {
      console.error("Error saving intake form:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An error occurred while saving the form.";
      toast.error(errorMessage);
    }
  };

  const renderQuestionContent = (
    record: any,
    idx: number,
    showCategoryTitle: boolean = false,
    categoryName?: string
  ) => {
    const answerType = getRecordProperty(record, "answerType");
    const options = getRecordProperty(record, "options");
    const questionId = getRecordProperty(record, "questionId");

    const inputWrapperTitle =
      showCategoryTitle && categoryName ? categoryName : undefined;

    const serialNumber = idx + 1;
    const error = formErrors[questionId];

    return (
      <div
        key={record._id || questionId || idx}
        className={PatientStyle.question_container}
      >
        {answerType === "single_option" && (
          <InputWrapper
            subTitle={
              <span
                style={{
                  color:
                    isEditable &&
                    (!formState[getRecordProperty(record, "questionId")] ||
                      (Array.isArray(
                        formState[getRecordProperty(record, "questionId")]
                      ) &&
                        formState[getRecordProperty(record, "questionId")]
                          .length === 0))
                      ? "red"
                      : "inherit",
                }}
              >
                {`${serialNumber}. ${record.text}`}
              </span>
            }
            title={inputWrapperTitle}
            error={error}
          >
            {isEditable ? (
              <div className={PatientStyle.option_container}>
                {options.map((opt: any) => (
                  <div key={opt.key} className={PatientStyle.option_row}>
                    <RadioButton
                      label={opt.name}
                      checked={formState[questionId] === opt.name}
                      onChange={() => {
                        updateState(questionId, opt.name);

                        // Clear other textbox values when changing selection
                        options.forEach((otherOpt: any) => {
                          if (
                            otherOpt.name !== opt.name &&
                            otherOpt.textboxRequired === "yes"
                          ) {
                            updateState(
                              `${questionId}_${otherOpt.name}_textbox`,
                              ""
                            );
                          }
                        });
                      }}
                    />
                    {opt.textboxRequired === "yes" &&
                      formState[questionId] === opt.name && (
                        <TextAreaField
                          rows={2}
                          placeholder="Please specify"
                          value={
                            formState[`${questionId}_${opt.name}_textbox`] || ""
                          }
                          onChange={(e) =>
                            updateState(
                              `${questionId}_${opt.name}_textbox`,
                              e.target.value
                            )
                          }
                        />
                      )}
                  </div>
                ))}
              </div>
            ) : (
              <div className={PatientStyle.option_container}>
                {options.map((opt: any) => {
                  const checked = record.answer === opt.name;
                  return (
                    <div key={opt.key} className={PatientStyle.option_row}>
                      <RadioButton
                        label={opt.name}
                        checked={checked}
                        onChange={() => {}}
                      />
                      {opt.textboxRequired === "yes" &&
                        checked &&
                        record.more_details?.[opt.name] && (
                          <TextAreaField
                            rows={2}
                            value={record.more_details[opt.name]}
                          />
                        )}
                    </div>
                  );
                })}
              </div>
            )}
          </InputWrapper>
        )}

        {answerType === "multiple_option" && (
          <InputWrapper
            subTitle={
              <span
                style={{
                  color:
                    isEditable &&
                    (!formState[getRecordProperty(record, "questionId")] ||
                      (Array.isArray(
                        formState[getRecordProperty(record, "questionId")]
                      ) &&
                        formState[getRecordProperty(record, "questionId")]
                          .length === 0))
                      ? "red"
                      : "inherit",
                }}
              >
                {`${serialNumber}. ${record.text}`}
              </span>
            }
            title={inputWrapperTitle}
            error={error}
          >
            <div className={PatientStyle.checkbox_div_1}>
              {options.map((opt: any) => {
                const checked = isEditable
                  ? (formState[questionId] || []).includes(opt.name)
                  : Array.isArray(record.answer) &&
                    record.answer.includes(opt.name);

                return (
                  <div key={opt.key} className={PatientStyle.option_row}>
                    <CheckboxInput
                      label={opt.name}
                      checked={checked}
                      onChange={() =>
                        isEditable && toggleCheckbox(questionId, opt.name)
                      }
                    />
                    {opt.textboxRequired === "yes" && checked && (
                      <TextAreaField
                        rows={2}
                        placeholder="Please specify"
                        value={
                          isEditable
                            ? formState[`${questionId}_${opt.name}_textbox`] ||
                              ""
                            : record.more_details?.[opt.name] || ""
                        }
                        onChange={(e) =>
                          isEditable &&
                          updateState(
                            `${questionId}_${opt.name}_textbox`,
                            e.target.value
                          )
                        }
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </InputWrapper>
        )}

        {answerType === "textarea" && (
          <InputWrapper
            subTitle={
              <span
                style={{
                  color:
                    isEditable &&
                    (!formState[getRecordProperty(record, "questionId")] ||
                      (Array.isArray(
                        formState[getRecordProperty(record, "questionId")]
                      ) &&
                        formState[getRecordProperty(record, "questionId")]
                          .length === 0))
                      ? "red"
                      : "inherit",
                }}
              >
                {`${serialNumber}. ${record.text}`}
              </span>
            }
            title={inputWrapperTitle}
            error={error}
          >
            {isEditable ? (
              <TextAreaField
                rows={4}
                value={formState[questionId] || ""}
                onChange={(e) => updateState(questionId, e.target.value)}
              />
            ) : (
              <div className={PatientStyle.text_answer}>
                <p>{record.answer?.toString() || "No answer provided"}</p>
              </div>
            )}
          </InputWrapper>
        )}

        {answerType === "scale" && (
          <InputWrapper
            subTitle={
              <span
                style={{
                  color:
                    isEditable &&
                    (formState[questionId] === null ||
                      formState[questionId] === undefined) &&
                    !touchedFields[questionId]
                      ? "red"
                      : "inherit",
                }}
              >
                {`${serialNumber}. ${record.text}`}
              </span>
            }
            title={inputWrapperTitle}
            error={error}
          >
            <SliderBar
              scale
              value={
                isEditable
                  ? formState[questionId] ?? 0
                  : typeof record.answer === "number"
                  ? record.answer
                  : typeof record.answer === "string"
                  ? parseInt(record.answer) ?? 0
                  : 0
              }
              onChange={(value: number) => {
                updateState(questionId, value);
                setTouchedFields((prev) => ({ ...prev, [questionId]: true }));
              }}
              onClick={(value: number) => {
                updateState(questionId, value);
                setTouchedFields((prev) => ({ ...prev, [questionId]: true }));
              }}
              customLabel
              min={record.scale?.min?.key ? parseInt(record.scale.min.key) : 0}
              max={record.scale?.max?.key ? parseInt(record.scale.max.key) : 10}
              leftLabel={record.scale?.min?.name || "Min"}
              rightLabel={record.scale?.max?.name || "Max"}
              disabled={!isEditable}
            />
          </InputWrapper>
        )}
      </div>
    );
  };

  return (
    <Modal show={props.show} modalClassName={PatientStyle.customEnrollModal}>
      <Modal show={showConfirmModal}>
        <ModalHeading heading="Cancel Edit" />
        <ModalForm
          style={{ marginBottom: "2.5rem" }}
          onSubmit={(e) => {
            e.preventDefault();
            handleConfirmCancel();
          }}
        >
          <InputWrapper>
            <p className="primaryText">
              Are you sure you want to cancel editing? All changes will be lost.
            </p>
          </InputWrapper>

          <ModalButtons
            submitButtonLabel="Confirm"
            cancelButtonLabel="Cancel"
            onCancel={handleAbortCancel}
          />
        </ModalForm>
      </Modal>
      <ModalHeading
        heading={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingTop: "0.5rem",
            }}
          >
            <span
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span>
                {isEditable
                  ? intakeFormTemplate?.data.templateName || "Edit Intake Form"
                  : "Patient Intake Form"}
              </span>
              {
                <small
                  style={{ fontSize: "1.4rem", color: "var(--grey-new2)" }}
                >
                  Patient Name: {props.patient?.name}
                </small>
              }
            </span>

            {!props.intakeFormStatusLoading &&
              !isEditable &&
              (props.canEdit === "yes" ||
                props.patient.rtmStatus === "Active") && (
                <div style={{ marginLeft: "1rem" }}>
                  <Button
                    label="Edit"
                    icon="icon-edit-2"
                    span={false}
                    iconStyle={{ height: "1.5rem", width: "1.5rem" }}
                    customClass={PatientStyle.save_data_btn}
                    onClick={handleEditClick}
                  />
                </div>
              )}
          </div>
        }
        customClass={[PatientStyle.customEnrollHeading1].join(" ")}
        customCloseClass={PatientStyle.close_btn}
        closeIcon="close-cross"
        onClose={isEditable ? handleCancelEdit : props.onClose}
      />

      {intakeFormLoading || (isEditable && templateLoading) ? (
        <SkeletonLoader />
      ) : (
        <ModalForm customClass={PatientStyle.enroll_ModalForm} id="intake-form">
          <div
            className={PatientStyle.enroll_ModalForm_inner}
            style={{ marginBottom: "1rem" }}
          >
            {isEditable ? (
              intakeFormTemplate?.data?.data ? (
                intakeFormTemplate.data.data.map((category, categoryIdx) => (
                  <div
                    key={category._id || `category-${categoryIdx}`}
                    className={PatientStyle.custom_content}
                  >
                    {category.records &&
                      category.records.map((record, idx) =>
                        renderQuestionContent(
                          record,
                          idx,
                          idx === 0,
                          category.name
                        )
                      )}
                  </div>
                ))
              ) : (
                <p>No intake form template available for editing.</p>
              )
            ) : !intakeFormData || intakeFormData.length === 0 ? (
              <p>No intake form data available for this patient.</p>
            ) : (
              intakeFormData.map((category, categoryIdx) => (
                <div
                  key={category._id || `category-${categoryIdx}`}
                  className={PatientStyle.custom_content}
                >
                  {category.records &&
                    category.records.map((record, idx) =>
                      renderQuestionContent(
                        record,
                        idx,
                        idx === 0,
                        category.name
                      )
                    )}
                </div>
              ))
            )}
          </div>
          <div className={PatientStyle.custom_btn_box}>
            {isEditable ? (
              <>
                <Button
                  label="Cancel"
                  icon="icon-close-cross"
                  span={false}
                  iconStyle={{ height: "1.5rem", width: "1.5rem" }}
                  customClass={PatientStyle.cancel_btn}
                  onClick={handleCancelEdit}
                  form="intake-form"
                />
                <Button
                  icon="icon-save"
                  label={isUpdating ? "Saving..." : "Save"}
                  span={false}
                  iconStyle={{ height: "1.5rem", width: "1.5rem" }}
                  customClass={PatientStyle.save_data_btn}
                  onClick={handleSaveEdit}
                  disabled={isUpdating}
                />
              </>
            ) : (
              <Button
                label="Close"
                icon="icon-close-cross"
                span={false}
                iconStyle={{ height: "1.5rem", width: "1.5rem" }}
                customClass={PatientStyle.cancel_btn}
                onClick={props.onClose}
                form="intake-form"
              />
            )}
          </div>
        </ModalForm>
      )}
    </Modal>
  );
};

export default IntakeFormViewModal;
